import React from 'react';
import { useTranslation } from 'react-i18next';

const ConfirmDialog = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  confirmText, 
  cancelText,
  type = 'danger' // danger, warning, info
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="dialog-backdrop" onClick={handleBackdropClick}>
      <div className="dialog-shell" onClick={(e) => e.stopPropagation()}>
        {title && (
          <h3
            className="dialog-shell__title"
            style={{
              color: type === 'danger'
                ? '#ffbeb6'
                : type === 'warning'
                  ? '#f8d58d'
                  : 'var(--text-primary)'
            }}
          >
            {title}
          </h3>
        )}

        <p className="dialog-shell__message">
          {message}
        </p>

        <div className="dialog-shell__actions">
          <button
            type="button"
            onClick={onClose}
            className="theme-button theme-button--ghost"
          >
            {cancelText || t('common.cancel')}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className={`theme-button ${
              type === 'danger'
                ? 'theme-button--danger'
                : type === 'warning'
                  ? 'theme-button--secondary'
                  : 'theme-button--primary'
            }`}
          >
            {confirmText || t('common.confirm')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog; 
